import React, { useEffect, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { API } from "../../config/api";
import { FaSync, FaFileInvoiceDollar, FaFileExcel, FaLock, FaEye, FaSearch, FaEdit, FaTrashAlt } from "react-icons/fa";
import ReactPaginate from "react-paginate";
import "bulma/css/bulma.css";
import "../../index.css";
import swal from "sweetalert";
import Select from "react-select";
import * as XLSX from "xlsx";
import LoaderHome from "../Loader/LoaderHome";
import ModalPassword from "./ModalPassword";
import SlipGajiModal from "./SlipGajiModal";
import EditSalarySlipModal from "./EditSalarySlipModal";

// Helper format rupiah
const formatRupiah = (number) => {
  if (number === null || number === undefined || isNaN(number)) return "Rp 0";
  return new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    maximumFractionDigits: 0,
  }).format(number);
};

export default function ListDataSalarySlip() {
  document.title = "Manajemen Slip Gaji";
  const [getData, setGetData] = useState([]);
  const [getDataTotal, setGetDataTotal] = useState(0);
  const [getDataBranch, setGetDataBranch] = useState([]);
  const [getDataSchool, setGetDataSchool] = useState([]);
  const [getDataTeacher, setGetDataTeacher] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(25);
  const [ascending, setAscending] = useState(0);
  const [keyword, setKeyword] = useState("");
  const [loading, setLoading] = useState(false);
  const [isImporting, setIsImporting] = useState(false);

  // Detail & Edit Modal State
  const [showSlipModal, setShowSlipModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedSlip, setSelectedSlip] = useState(null);
  const [selectedEditSlip, setSelectedEditSlip] = useState(null);

  // Checkbox Bulk Selection State
  const [selectedIds, setSelectedIds] = useState([]);

  const token = localStorage.getItem("token");
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 780px)" });
  const storageLevel = localStorage.getItem("level");
  const storageBranchGroping = localStorage.getItem("ysb_branch_id");
  const [storageBranch, setStorageBranch] = useState("");

  const currentYear = new Date().getFullYear();
  const arrayTahun = [currentYear - 2, currentYear - 1, currentYear, currentYear + 1, currentYear + 2];

  const [form, setForm] = useState({
    month: "",
    year: String(currentYear),
    ysb_branch_id: "",
    ysb_school_id: "",
    ysb_teacher_id: "",
  });

  const [selectTeacherKey, setSelectTeacherKey] = useState(0);

  useEffect(() => {
    const br = localStorage.getItem("ysb_branch_id") || "";
    setStorageBranch(br);
    if (br !== "" && storageLevel !== "developer" && storageLevel !== "superadmin") {
      setForm((prev) => ({ ...prev, ysb_branch_id: br }));
    }
  }, [storageLevel]);

  let fetchParams = {
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
  };

  // Fetch initial master branches
  const fetchData = async () => {
    try {
      setLoading(true);
      const resBranch = await API.get(
        `/api/branches?page=1&limit=100&ascending=1&search=&branch=${storageBranchGroping}&level=${storageLevel}`,
        fetchParams
      );
      if (resBranch.status === 200) {
        setGetDataBranch(resBranch.data.data || []);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      swal({
        title: "Gagal Mengambil Data Cabang",
        text: error?.response?.data?.message || "Terjadi kesalahan koneksi",
        icon: "error",
      });
    }
  };

  useEffect(() => {
    fetchData();
    GetSalarySlips();
  }, []);

  // Load schools when branch changes
  useEffect(() => {
    if (form.ysb_branch_id) {
      GetSchools(form.ysb_branch_id);
    } else {
      setGetDataSchool([]);
      setGetDataTeacher([]);
    }
  }, [form.ysb_branch_id]);

  // Load teachers when school changes
  useEffect(() => {
    if (form.ysb_school_id) {
      GetTeachers(form.ysb_school_id);
    } else {
      setGetDataTeacher([]);
    }
  }, [form.ysb_school_id]);

  const GetSchools = async (branchCode) => {
    try {
      const response = await API.get(
        `/api/schools/super?page=1&limit=100&ascending=1&branch=${branchCode}&level=${storageLevel}`,
        fetchParams
      );
      if (response?.status === 200) {
        setGetDataSchool(response.data.data || []);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const GetTeachers = async (schoolCode) => {
    try {
      const response = await API.get(
        `/api/teachers/all?page=1&limit=300&ascending=1&ascending_name=true&ysb_school_id=${schoolCode}`,
        fetchParams
      );
      if (response?.status === 200) {
        setGetDataTeacher(response.data.data || []);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const GetSalarySlips = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams({
        page: String(page),
        limit: String(limit),
        ascending: String(ascending),
        search: keyword,
        month: form.month,
        year: form.year,
        branch: form.ysb_branch_id,
        ysb_school_id: form.ysb_school_id,
        ysb_teacher_id: form.ysb_teacher_id,
        level: storageLevel || "",
      });

      const response = await API.get(`/api/salary-slips?${params.toString()}`, fetchParams);

      if (response?.status === 200) {
        const rawData = response.data.data || [];
        // Urutkan alfabetis berdasarkan nama (A-Z) agar rapi
        const sortedData = rawData.slice().sort((a, b) => (a.nama || "").localeCompare(b.nama || ""));
        setGetData(sortedData);
        setGetDataTotal(response.data.total || 0);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      swal({
        title: "Gagal Mengambil Data Slip Gaji",
        text: error?.response?.data?.message || "Terjadi kesalahan saat memuat data.",
        icon: "error",
      });
    }
  };

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleTeacherChange = (selected) => {
    setForm({
      ...form,
      ysb_teacher_id: selected ? selected.value : "",
    });
  };

  // Handler for Excel Import
  const handleImportExcel = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.name.match(/\.(xlsx|xls)$/)) {
      swal({
        title: "Format File Salah",
        text: "Hanya file berekstensi .xlsx atau .xls yang diizinkan.",
        icon: "error",
      });
      return;
    }

    setIsImporting(true);

    try {
      const arrayBuffer = await file.arrayBuffer();
      const workbook = XLSX.read(arrayBuffer, { type: "array" });

      if (!workbook.SheetNames || workbook.SheetNames.length === 0) {
        throw new Error("File Excel tidak memiliki lembar sheet data.");
      }

      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      const rawRows = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: "" });

      if (rawRows.length < 2) {
        swal({
          title: "Data Kosong",
          text: "Sheet Excel tidak memiliki baris data untuk diimport.",
          icon: "info",
        });
        setIsImporting(false);
        return;
      }

      // Filter baris yang tidak kosong
      const dataToImport = rawRows.filter((r) => r && r.length > 0 && r[0] !== "");

      const payload = {
        data: dataToImport,
        month: form.month || "",
        year: form.year || "",
        ysb_branch_id: form.ysb_branch_id || "",
        ysb_school_id: form.ysb_school_id || "",
        ysb_teacher_id: form.ysb_teacher_id || "",
      };

      const response = await API.post("/api/salary-slips/import", payload, fetchParams);

      if (response?.status === 200) {
        swal({
          title: "Import Berhasil!",
          text: response.data.message || "Data slip gaji berhasil diimport ke sistem.",
          icon: "success",
        });
        await GetSalarySlips();
      }
    } catch (error) {
      console.error("Error import excel:", error);
      swal({
        title: "Gagal Memproses File Excel",
        text: error?.response?.data?.message || error.message || "Terjadi kesalahan saat parsing Excel.",
        icon: "error",
      });
    } finally {
      setIsImporting(false);
      e.target.value = "";
    }
  };

  // Click on "Buka Slip Gaji" (Langsung buka tanpa verifikasi password untuk Superadmin)
  const handleOpenSlip = (slip) => {
    setSelectedSlip(slip);
    setShowSlipModal(true);
  };

  // Click on "Edit Slip Gaji"
  const handleOpenEdit = (slip) => {
    setSelectedEditSlip(slip);
    setShowEditModal(true);
  };

  // Click on "Hapus Slip Gaji"
  const handleDeleteSlip = (slip) => {
    swal({
      title: "Hapus Slip Gaji?",
      text: `Apakah Anda yakin ingin menghapus slip gaji ${slip.nama || "guru"} periode ${slip.periode || "-"}? Data yang dihapus tidak dapat dikembalikan.`,
      icon: "warning",
      buttons: ["Batal", "Ya, Hapus!"],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          const response = await API.delete(`/api/salary-slips/${slip.id}`, fetchParams);
          if (response?.status === 200) {
            swal({
              title: "Berhasil Dihapus!",
              text: response.data.message || "Data slip gaji berhasil dihapus.",
              icon: "success",
            });
            await GetSalarySlips();
          }
        } catch (error) {
          swal({
            title: "Gagal Menghapus",
            text: error?.response?.data?.message || "Terjadi kesalahan saat menghapus slip gaji.",
            icon: "error",
          });
        }
      }
    });
  };

  // Checkbox Selection Handlers
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      // Pilih semua data yang tampil di layar / filter saat ini
      const visibleIds = getData.map((item) => item.id).filter(Boolean);
      setSelectedIds(visibleIds);
    } else {
      setSelectedIds([]);
    }
  };

  const handleSelectRow = (id) => {
    setSelectedIds((prev) => {
      if (prev.includes(id)) {
        return prev.filter((item) => item !== id);
      } else {
        return [...prev, id];
      }
    });
  };

  const handleBulkDelete = () => {
    if (selectedIds.length === 0) return;

    swal({
      title: `Hapus ${selectedIds.length} Slip Gaji?`,
      text: `Apakah Anda yakin ingin menghapus ${selectedIds.length} data slip gaji yang dicentang di halaman ini? Data yang dihapus tidak dapat dikembalikan.`,
      icon: "warning",
      buttons: ["Batal", `Ya, Hapus (${selectedIds.length})!`],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          setLoading(true);
          const response = await API.post(
            "/api/salary-slips/bulk-delete",
            { ids: selectedIds },
            fetchParams
          );
          if (response?.status === 200) {
            swal({
              title: "Berhasil Dihapus!",
              text: response.data.message || `${selectedIds.length} data slip gaji berhasil dihapus.`,
              icon: "success",
            });
            setSelectedIds([]);
            await GetSalarySlips();
          }
        } catch (error) {
          swal({
            title: "Gagal Menghapus",
            text: error?.response?.data?.message || "Terjadi kesalahan saat menghapus data terpilih.",
            icon: "error",
          });
        } finally {
          setLoading(false);
        }
      }
    });
  };

  const handlePageChange = ({ selected }) => {
    setPage(selected + 1);
  };

  // Reset checklist saat pindah halaman atau filter berubah
  useEffect(() => {
    setSelectedIds([]);
  }, [page, limit, form.month, form.year, form.ysb_branch_id, form.ysb_school_id, form.ysb_teacher_id, keyword]);

  useEffect(() => {
    GetSalarySlips();
  }, [page, limit]);

  return (
    <div style={{ padding: isTabletOrMobile ? "10px" : "20px", fontFamily: "Poppins, sans-serif" }}>
      {/* Header Title & Breadcrumb */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "#ffffff",
          padding: "16px 20px",
          borderRadius: "10px",
          boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
          marginBottom: "20px",
          flexWrap: "wrap",
          gap: "10px",
        }}
      >
        <div>
          <h4 style={{ margin: 0, fontWeight: "bold", color: "#00487F", display: "flex", alignItems: "center", gap: "10px" }}>
            <FaFileInvoiceDollar /> Data Slip
          </h4>
          <p style={{ margin: "4px 0 0 0", fontSize: "13px", color: "#6b7280" }}>
            Kelola, import, dan cetak slip gaji guru dan staf yayasan secara terpadu.
          </p>
        </div>

        {/* Action Buttons: Import Excel & Refresh */}
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <button
            onClick={() => document.getElementById("excelImportInput").click()}
            disabled={isImporting}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontSize: "13px",
              padding: "9px 18px",
              borderRadius: "8px",
              backgroundColor: isImporting ? "#9ca3af" : "#0284c7",
              color: "#fff",
              border: "none",
              cursor: isImporting ? "not-allowed" : "pointer",
              fontWeight: "500",
              boxShadow: "0 2px 4px rgba(2, 132, 199, 0.2)",
            }}
          >
            <FaFileExcel /> {isImporting ? "Mengimpor..." : "Import Excel"}
          </button>
          <input
            type="file"
            id="excelImportInput"
            accept=".xlsx,.xls"
            style={{ display: "none" }}
            onChange={handleImportExcel}
          />

          <button
            onClick={GetSalarySlips}
            title="Refresh Data"
            style={{
              padding: "9px 14px",
              borderRadius: "8px",
              backgroundColor: "#f3f4f6",
              color: "#00487F",
              border: "1px solid #d1d5db",
              cursor: "pointer",
            }}
          >
            <FaSync />
          </button>
        </div>
      </div>

      {/* Filter Card (Super Admin / Admin HR) */}
      <div
        style={{
          backgroundColor: "#ffffff",
          padding: "16px 20px",
          borderRadius: "10px",
          boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
          marginBottom: "20px",
        }}
      >
        <div style={{ fontSize: "14px", fontWeight: "600", color: "#374151", marginBottom: "12px" }}>
          Filter Data Slip Gaji
        </div>

        <div className="row g-2 align-items-end">
          {/* Periode / Bulan */}
          <div className="col-lg-2 col-md-4 col-sm-6 col-12">
            <label style={{ fontSize: "12px", color: "#6b7280", marginBottom: "4px", display: "block" }}>Bulan / Periode</label>
            <select
              value={form.month}
              name="month"
              onChange={handleChange}
              style={{
                width: "100%",
                border: "1px solid #3272B3",
                borderRadius: "6px",
                height: "38px",
                fontSize: "13px",
                padding: "0 8px",
              }}
            >
              <option value="">Semua Periode</option>
              <option value="1">Desember-Januari (1)</option>
              <option value="2">Januari-Februari (2)</option>
              <option value="3">Februari-Maret (3)</option>
              <option value="4">Maret-April (4)</option>
              <option value="5">April-Mei (5)</option>
              <option value="6">Mei-Juni (6)</option>
              <option value="7">Juni-Juli (7)</option>
              <option value="8">Juli-Agustus (8)</option>
              <option value="9">Agustus-September (9)</option>
              <option value="10">September-Oktober (10)</option>
              <option value="11">Oktober-November (11)</option>
              <option value="12">November-Desember (12)</option>
            </select>
          </div>

          {/* Tahun */}
          <div className="col-lg-2 col-md-4 col-sm-6 col-12">
            <label style={{ fontSize: "12px", color: "#6b7280", marginBottom: "4px", display: "block" }}>Tahun</label>
            <select
              value={form.year}
              name="year"
              onChange={handleChange}
              style={{
                width: "100%",
                border: "1px solid #3272B3",
                borderRadius: "6px",
                height: "38px",
                fontSize: "13px",
                padding: "0 8px",
              }}
            >
              <option value="">Semua Tahun</option>
              {arrayTahun.map((th, idx) => (
                <option key={idx} value={String(th)}>
                  {th}
                </option>
              ))}
            </select>
          </div>

          {/* Cabang */}
          <div className="col-lg-2 col-md-4 col-sm-6 col-12">
            <label style={{ fontSize: "12px", color: "#6b7280", marginBottom: "4px", display: "block" }}>Cabang</label>
            <select
              value={form.ysb_branch_id}
              name="ysb_branch_id"
              onChange={handleChange}
              // disabled={storageLevel !== "developer" && storageLevel !== "superadmin" && storageBranch !== ""}
              style={{
                width: "100%",
                border: "1px solid #3272B3",
                borderRadius: "6px",
                height: "38px",
                fontSize: "13px",
                padding: "0 8px",
                // backgroundColor:
                //   storageLevel !== "developer" && storageLevel !== "superadmin" && storageBranch !== ""
                //     ? "#f3f4f6"
                //     : "#ffffff",
              }}
            >
              <option value="" hidden>Semua Cabang</option>
              {getDataBranch.map((br, index) => (
                <option key={index} value={br.branch_code}>
                  {br.branch_name}
                </option>
              ))}
            </select>
          </div>

          {/* Sekolah */}
          <div className="col-lg-2 col-md-4 col-sm-6 col-12">
            <label style={{ fontSize: "12px", color: "#6b7280", marginBottom: "4px", display: "block" }}>Sekolah</label>
            <select
              value={form.ysb_school_id}
              name="ysb_school_id"
              onChange={handleChange}
              style={{
                width: "100%",
                border: "1px solid #3272B3",
                borderRadius: "6px",
                height: "38px",
                fontSize: "13px",
                padding: "0 8px",
              }}
            >
              <option value="">Semua Sekolah</option>
              {getDataSchool.map((sc, index) => (
                <option key={index} value={sc.school_code}>
                  {sc.school_code} - {sc.school_name || ""}
                </option>
              ))}
            </select>
          </div>

          {/* Guru */}
          <div className="col-lg-3 col-md-5 col-sm-8 col-12">
            <label style={{ fontSize: "12px", color: "#6b7280", marginBottom: "4px", display: "block" }}>Guru / Karyawan</label>
            <Select
              key={selectTeacherKey}
              isClearable
              onChange={handleTeacherChange}
              options={getDataTeacher.map((t) => ({
                value: t.id,
                label: `${t.full_name} (${t.nip_ypi || t.nik_ysb || "-"})`,
              }))}
              placeholder="Cari nama guru..."
              styles={{
                control: (base) => ({
                  ...base,
                  borderColor: "#3272B3",
                  borderRadius: "6px",
                  minHeight: "38px",
                  height: "38px",
                  fontSize: "13px",
                }),
                menu: (base) => ({
                  ...base,
                  zIndex: 9999,
                  fontSize: "13px",
                }),
              }}
            />
          </div>

          {/* Tombol Submit Filter */}
          <div className="col-lg-1 col-md-3 col-sm-4 col-12">
            <label style={{ fontSize: "12px", color: "#6b7280", marginBottom: "4px", display: "block", visibility: "hidden" }}>Aksi</label>
            <button
              onClick={GetSalarySlips}
              style={{
                width: "100%",
                height: "38px",
                backgroundColor: "#00487F",
                color: "#ffffff",
                border: "none",
                borderRadius: "6px",
                fontSize: "13px",
                fontWeight: "500",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "6px",
              }}
            >
              <FaSearch /> Filter
            </button>
          </div>
        </div>
      </div>

      {/* Table Card */}
      <div
        style={{
          backgroundColor: "#ffffff",
          padding: "20px",
          borderRadius: "10px",
          boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
        }}
      >
        {/* Search Bar & Limit */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "16px",
            flexWrap: "wrap",
            gap: "10px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "13px", color: "#4b5563" }}>
            <span>Tampilkan</span>
            <select
              value={limit}
              onChange={(e) => setLimit(Number(e.target.value))}
              style={{ border: "1px solid #d1d5db", borderRadius: "4px", padding: "4px 8px" }}
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
            <span>data per halaman</span>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <input
              type="text"
              placeholder="Cari nama, NIP, no rek..."
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && GetSalarySlips()}
              style={{
                padding: "6px 12px",
                fontSize: "13px",
                border: "1px solid #3272B3",
                borderRadius: "6px",
                outline: "none",
                width: isTabletOrMobile ? "100%" : "260px",
              }}
            />
            <button
              onClick={GetSalarySlips}
              style={{
                padding: "6px 14px",
                backgroundColor: "#00487F",
                color: "white",
                border: "none",
                borderRadius: "6px",
                fontSize: "13px",
                cursor: "pointer",
              }}
            >
              Cari
            </button>
          </div>
        </div>

        {/* Bulk Delete Bar */}
        {selectedIds.length > 0 && (
          <div
            style={{
              backgroundColor: "#fef2f2",
              border: "1px solid #fecaca",
              borderRadius: "8px",
              padding: "10px 16px",
              marginBottom: "14px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: "10px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <span
                style={{
                  backgroundColor: "#ef4444",
                  color: "#ffffff",
                  padding: "3px 10px",
                  borderRadius: "20px",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                {selectedIds.length} Data Terpilih
              </span>
              <span style={{ fontSize: "13px", color: "#991b1b", fontWeight: "500" }}>
                Data yang dicentang di layar ini siap dihapus sekaligus.
              </span>
            </div>
            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <button
                onClick={() => setSelectedIds([])}
                style={{
                  backgroundColor: "#ffffff",
                  border: "1px solid #cbd5e1",
                  color: "#475569",
                  padding: "6px 14px",
                  borderRadius: "6px",
                  fontSize: "12px",
                  fontWeight: "500",
                  cursor: "pointer",
                }}
              >
                Batal Pilih
              </button>
              <button
                onClick={handleBulkDelete}
                style={{
                  backgroundColor: "#dc2626",
                  border: "none",
                  color: "#ffffff",
                  padding: "6px 16px",
                  borderRadius: "6px",
                  fontSize: "12px",
                  fontWeight: "600",
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "6px",
                  boxShadow: "0 2px 4px rgba(220, 38, 38, 0.25)",
                }}
              >
                <FaTrashAlt style={{ fontSize: "12px" }} /> Hapus Terpilih ({selectedIds.length})
              </button>
            </div>
          </div>
        )}

        {/* Table Content */}
        {loading ? (
          <div style={{ padding: "40px 0", textAlign: "center" }}>
            <LoaderHome />
          </div>
        ) : (
          <div className="table-responsive" style={{ overflowX: "auto" }}>
            <style>{`
              .salary-slip-table thead th {
                background-color: #00487F !important;
                color: #ffffff !important;
                text-align: center !important;
                vertical-align: middle !important;
                border-color: #003865 !important;
                font-weight: 600 !important;
                padding: 10px 8px !important;
              }
              .salary-slip-table tbody td {
                text-align: center !important;
                vertical-align: middle !important;
              }
            `}</style>
            <table className="table table-hover table-bordered salary-slip-table" style={{ fontSize: "13px", verticalAlign: "middle" }}>
              <thead style={{ backgroundColor: "#00487F", color: "#ffffff", textAlign: "center" }}>
                <tr>
                  <th style={{ width: "80px", backgroundColor: "#00487F", color: "#ffffff", textAlign: "center", verticalAlign: "middle" }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
                      <input
                        type="checkbox"
                        style={{
                          cursor: "pointer",
                          width: "16px",
                          height: "16px",
                          accentColor: "#0284c7",
                        }}
                        title="Pilih Semua di Halaman Ini"
                        checked={getData.length > 0 && selectedIds.length === getData.length}
                        onChange={handleSelectAll}
                      />
                      <span>No</span>
                    </div>
                  </th>
                  <th style={{ backgroundColor: "#00487F", color: "#ffffff", textAlign: "center" }}>Nama Guru / Karyawan</th>
                  <th style={{ backgroundColor: "#00487F", color: "#ffffff", textAlign: "center" }}>NIP YPI</th>
                  <th style={{ backgroundColor: "#00487F", color: "#ffffff", textAlign: "center" }}>Periode</th>
                  <th style={{ backgroundColor: "#00487F", color: "#ffffff", textAlign: "center" }}>Unit / Sekolah</th>
                  <th style={{ backgroundColor: "#00487F", color: "#ffffff", textAlign: "center" }}>Gaji Pokok</th>
                  <th style={{ backgroundColor: "#00487F", color: "#ffffff", textAlign: "center" }}>Total Pendapatan</th>
                  <th style={{ backgroundColor: "#00487F", color: "#ffffff", textAlign: "center" }}>Total Potongan</th>
                  <th style={{ backgroundColor: "#00487F", color: "#ffffff", textAlign: "center" }}>Ditransfer</th>
                  <th style={{ width: "220px", backgroundColor: "#00487F", color: "#ffffff", textAlign: "center" }}>Aksi</th>
                </tr>
              </thead>
              <tbody>
                {getData && getData.length > 0 ? (
                  getData.map((item, index) => {
                    const rowNumber = (page - 1) * limit + index + 1;
                    const ditransferVal = item.ditransfer || item.total_pendapatan - item.jumlah_potongan || 0;
                    const isRowSelected = selectedIds.includes(item.id);
                    return (
                      <tr
                        key={item.id || index}
                        style={{
                          backgroundColor: isRowSelected ? "#f0f9ff" : "inherit",
                          transition: "background-color 0.15s ease",
                        }}
                      >
                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
                            <input
                              type="checkbox"
                              style={{
                                cursor: "pointer",
                                width: "15px",
                                height: "15px",
                                accentColor: "#0284c7",
                              }}
                              checked={isRowSelected}
                              onChange={() => handleSelectRow(item.id)}
                            />
                            <span style={{ fontWeight: isRowSelected ? "bold" : "normal" }}>{rowNumber}</span>
                          </div>
                        </td>
                        <td style={{ textAlign: "center", verticalAlign: "middle", fontWeight: "600", color: "#1e293b" }}>{item.nama || "-"}</td>
                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>{item.nip_ypi || "-"}</td>
                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                          <span
                            style={{
                              backgroundColor: "#e0f2fe",
                              color: "#0369a1",
                              padding: "4px 10px",
                              borderRadius: "4px",
                              fontWeight: "600",
                              fontSize: "12px",
                              display: "inline-block",
                            }}
                          >
                            {item.periode || "-"}
                          </span>
                        </td>
                        <td style={{ textAlign: "center", verticalAlign: "middle", fontSize: "12px" }}>
                          {item.unit_sekolah || item.school?.school_name || item.ysb_school_id || "-"}
                        </td>
                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>{formatRupiah(item.gaji_pokok)}</td>
                        <td style={{ textAlign: "center", verticalAlign: "middle", color: "#166534", fontWeight: "600" }}>
                          {formatRupiah(item.total_pendapatan)}
                        </td>
                        <td style={{ textAlign: "center", verticalAlign: "middle", color: "#991b1b", fontWeight: "600" }}>
                          {formatRupiah(item.jumlah_potongan || item.rekap_potongan)}
                        </td>
                        <td style={{ textAlign: "center", verticalAlign: "middle", fontWeight: "bold", color: "#00487F", fontSize: "14px" }}>
                          {formatRupiah(ditransferVal)}
                        </td>
                        <td style={{ textAlign: "center", verticalAlign: "middle", whiteSpace: "nowrap" }}>
                          <div style={{ display: "inline-flex", gap: "6px", alignItems: "center", justifyContent: "center" }}>
                            <button
                              onClick={() => handleOpenSlip(item)}
                              title="Buka & Cetak Slip Gaji"
                              style={{
                                backgroundColor: "#00487F",
                                color: "#ffffff",
                                border: "none",
                                padding: "6px 10px",
                                borderRadius: "6px",
                                fontSize: "12px",
                                fontWeight: "500",
                                cursor: "pointer",
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              <FaEye style={{ fontSize: "11px" }} /> Buka
                            </button>
                            <button
                              onClick={() => handleOpenEdit(item)}
                              title="Edit Angka & Data Absensi"
                              style={{
                                backgroundColor: "#f59e0b",
                                color: "#ffffff",
                                border: "none",
                                padding: "6px 10px",
                                borderRadius: "6px",
                                fontSize: "12px",
                                fontWeight: "500",
                                cursor: "pointer",
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              <FaEdit style={{ fontSize: "11px" }} /> Edit
                            </button>
                            <button
                              onClick={() => handleDeleteSlip(item)}
                              title="Hapus Slip Gaji"
                              style={{
                                backgroundColor: "#ef4444",
                                color: "#ffffff",
                                border: "none",
                                padding: "6px 10px",
                                borderRadius: "6px",
                                fontSize: "12px",
                                fontWeight: "500",
                                cursor: "pointer",
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              <FaTrashAlt style={{ fontSize: "11px" }} /> Hapus
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={10} style={{ textAlign: "center", padding: "30px", color: "#6b7280" }}>
                      Tidak ada data slip gaji yang ditemukan. Silakan sesuaikan filter atau import data Excel.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}

        {/* Pagination */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "16px",
            flexWrap: "wrap",
            gap: "10px",
            fontSize: "13px",
            color: "#6b7280",
          }}
        >
          <div>
            Menampilkan {getData.length > 0 ? (page - 1) * limit + 1 : 0} sampai{" "}
            {Math.min(page * limit, getDataTotal)} dari {getDataTotal} total data
          </div>

          <ReactPaginate
            previousLabel={"« Prev"}
            nextLabel={"Next »"}
            pageCount={Math.ceil(getDataTotal / limit) || 1}
            onPageChange={handlePageChange}
            containerClassName={"pagination justify-content-end mb-0"}
            pageClassName={"page-item"}
            pageLinkClassName={"page-link"}
            previousClassName={"page-item"}
            previousLinkClassName={"page-link"}
            nextClassName={"page-item"}
            nextLinkClassName={"page-link"}
            activeClassName={"active"}
            forcePage={page - 1}
          />
        </div>
      </div>

      {/* Modal Detail Slip Gaji (Printable) */}
      <SlipGajiModal
        show={showSlipModal}
        handleClose={() => setShowSlipModal(false)}
        data={selectedSlip}
      />

      {/* Modal Edit Slip Gaji & Data Absensi */}
      <EditSalarySlipModal
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        data={selectedEditSlip}
        onSuccess={GetSalarySlips}
      />
    </div>
  );
}
